module.exports = __webpack_public_path__ + "media/images/icons/country_flags/lk-853b4c532f4f09f5f74a722be8515785.svg";